import React from "react";
import {
  Image,
  Text,
  VStack,
  TextProps,
  StackProps,
  ImageProps
} from "@chakra-ui/react";
import logo from "assets/logo.png";
import { getImageUrl } from "duck";

interface InputViewProps extends StackProps {
  label: React.ReactNode;
  value?: string | number | null;
  type?: "text" | "image";
  labelProps?: TextProps;
  textValueProps?: TextProps;
  imageProps?: ImageProps;
}

const InputView: React.FC<InputViewProps> = ({
  label,
  value,
  type = "text",
  labelProps,
  textValueProps,
  imageProps,
  ...rest
}) => {
  return (
    <VStack align="start" {...rest}>
      <Text {...labelProps} color="black" fontWeight="medium">
        {label}
      </Text>
      {type === "text" && (
        <Text
          {...textValueProps}
          color="gray.900"
          fontSize="sm"
          lineHeight="5"
          fontWeight="normal"
        >
          {value || "-"}
        </Text>
      )}
      {type === "image" && (
        <Image
          objectFit="cover"
          src={value ? getImageUrl(+value) : logo}
          {...(value ? { boxSize: "120px" } : { w: "78px", h: "30px" })}
          alt="Logo"
          {...imageProps}
        />
      )}
    </VStack>
  );
};

export default InputView;
